import React from 'react';
import GlossaryFilterStore, { GLOSSARY_FILTER_DEFAULT_SORT_OPTION } from "../flux/GlossaryFilterStore";
import buttonMutedStyle from '../utils/buttonMutedStyle';
import { Link } from "react-router-dom";
import styled from "styled-components";
import Filter from "../icons/Filter";

const headerMenuNavLinkStyle = {
  display: 'flex',
  alignItems: 'center',
};

export default function GlossaryFilterIcon() {
  const currentFilter = GlossaryFilterStore.getState();

  const hasEnabledFilter = (
    currentFilter.currentSortOption !== GLOSSARY_FILTER_DEFAULT_SORT_OPTION ||
    currentFilter.currentFilterTagList.length > 0
  );

  return (
    <Link
      to="/glossary-filter"
      style={{
        ...headerMenuNavLinkStyle,
        ...buttonMutedStyle,
        position: 'relative',
        padding: '0 .75rem',
      }}>
      {hasEnabledFilter && <Badge />}
      <Filter style={{ width: '1.25rem' }} />
    </Link>
  );
};

const Badge = styled.div`
  position: absolute;
  top: 0;
  right: .3125rem;
  width: .4375rem;
  height: .4375rem;
  background-color: #CB1618;
  border-radius: 50%;
`;
